namespace PaperTrail.Web.Modules.NewsletterControl.Newsletter {
    export interface InviteContributorsResponse extends Serenity.ServiceResponse {
        IsSuccess?: boolean;
        Message?: string;
    }
}
